import {
  AbstractControl,
  FormArray,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';

/** Un FormArray doit contenir au moins `min` éléments */
export function minLengthArray(min: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null =>
    (control as FormArray).length >= min ? null : { minLengthArray: { min } };
}

/** Sur un créneau : l'heure de fin doit être après l'heure de début ("HH:mm") */
export function heuresValides(group: AbstractControl): ValidationErrors | null {
  const debut = group.get('debut')?.value;
  const fin = group.get('fin')?.value;
  if (!debut || !fin) {
    return null;
  }
  return fin > debut ? null : { heuresInvalides: true };
}

// ===== DÉBUT AJOUT : contrôle de chevauchement =====
/**
 * Sur une ville : refuse deux créneaux qui se chevauchent le même jour,
 * quelle que soit la salle (une activité = une seule session à la fois par ville).
 */
export function pasDeChevauchement(
  lieu: AbstractControl,
): ValidationErrors | null {
  const jours = (lieu.get('jours')?.value ?? []) as any[];

  const parDate = new Map<string, { debut: string; fin: string }[]>();
  for (const jour of jours) {
    if (!jour?.date) {
      continue;
    }
    for (const c of jour.creneaux ?? []) {
      if (!c?.debut || !c?.fin) {
        continue;
      }
      const liste = parDate.get(jour.date) ?? [];
      liste.push({ debut: c.debut, fin: c.fin });
      parDate.set(jour.date, liste);
    }
  }

  for (const [date, creneaux] of parDate) {
    const tries = [...creneaux].sort((a, b) => a.debut.localeCompare(b.debut));
    for (let i = 1; i < tries.length; i++) {
      const precedent = tries[i - 1];
      const courant = tries[i];
      if (courant.debut < precedent.fin) {
        const [a, m, j] = date.split('-');
        return {
          chevauchement: {
            date: `${j}/${m}/${a}`,
            creneau1: `${precedent.debut}–${precedent.fin}`,
            creneau2: `${courant.debut}–${courant.fin}`,
          },
        };
      }
    }
  }
  return null;
}
// ===== FIN AJOUT =====
// ===== DÉBUT AJOUT : date de fin après la date de début =====
/** Sur le formulaire : refuse une date de fin antérieure à la date de début */
export function dateFinApresDebut(
  form: AbstractControl,
): ValidationErrors | null {
  const debut = form.get('beginDate')?.value;
  const fin = form.get('closeDate')?.value;
  if (!debut || !fin) {
    return null;
  }
  // Format "yyyy-MM-dd" : la comparaison de texte suit l'ordre des dates
  return fin < debut ? { datesInversees: true } : null;
}
// ===== FIN AJOUT =====
